import { useState } from "react";
import type { Area, Point } from "react-easy-crop";
import { getCroppedBlob, readFileAsDataUrl } from "Utils/Image/ImageUtils";

const DEFAULT_MIME_TYPE = "image/jpeg";
const INITIAL_CROP: Point = { x: 0, y: 0 };
const INITIAL_ZOOM = 1;

export const useImageCrop = () => {
  const [imageSrc, setImageSrc] = useState<string | null>(null);
  const [mimeType, setMimeType] = useState<string>(DEFAULT_MIME_TYPE);
  const [crop, setCrop] = useState<Point>(INITIAL_CROP);
  const [zoom, setZoom] = useState(INITIAL_ZOOM);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<Area | null>(null);

  const open = async (file: File) => {
    const dataUrl = await readFileAsDataUrl(file);
    setMimeType(file.type);
    setImageSrc(dataUrl);
  };

  const close = () => {
    setImageSrc(null);
    setMimeType(DEFAULT_MIME_TYPE);
    setCrop(INITIAL_CROP);
    setZoom(INITIAL_ZOOM);
    setCroppedAreaPixels(null);
  };

  const getBlob = async (): Promise<Blob | null> => {
    if (!imageSrc || !croppedAreaPixels) {
      return null;
    }
    return getCroppedBlob(imageSrc, croppedAreaPixels, mimeType);
  };

  return {
    imageSrc,
    crop,
    zoom,
    croppedAreaPixels,
    setCrop,
    setZoom,
    setCroppedAreaPixels,
    open,
    close,
    getBlob,
  };
};
